import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AssessmentPage from "@/pages/AssessmentPage";
import ResultsPage from "@/pages/ResultsPage";
import ProgramsPage from "@/pages/ProgramsPage";
import BookingPage from "@/pages/BookingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/results/:programId" element={<ResultsPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
